(function () {
  const config = document.currentScript;
  const companyId = config.dataset.klaviyoCompany;
  const deferred = config.hasAttribute('data-load-on-interaction');
  let started = false;
  const events = ['pointerdown', 'touchstart', 'keydown', 'wheel'];
  const listenerOptions = { passive: true, capture: true };

  window._klOnsite = window._klOnsite || [];
  window._learnq = window._learnq || [];

  if (!window.klaviyo) {
    window.klaviyo = new Proxy({}, {
      get: function (_target, method) {
        if (method === 'push') {
          return function () {
            window._klOnsite.push.apply(window._klOnsite, arguments);
          };
        }
        return function () {
          const args = Array.from(arguments);
          const callback = typeof args[args.length - 1] === 'function' ? args.pop() : null;
          return new Promise(function (resolve) {
            window._klOnsite.push([method].concat(args, [function (result) {
              if (callback) callback(result);
              resolve(result);
            }]));
          });
        };
      }
    });
  }

  function loadKlaviyo() {
    if (started) return;
    started = true;
    events.forEach(function (eventName) {
      window.removeEventListener(eventName, onInteraction, listenerOptions);
    });
    if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) return;
    const script = document.createElement('script');
    script.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(companyId) + '/klaviyo.js?company_id=' + encodeURIComponent(companyId);
    script.async = true;
    script.dataset.luneaKlaviyo = 'true';
    script.addEventListener('error', function () {
      script.remove();
      started = false;
      events.forEach(function (eventName) {
        window.addEventListener(eventName, onInteraction, listenerOptions);
      });
    }, { once: true });
    document.head.appendChild(script);
  }

  function onInteraction() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadKlaviyo, { timeout: 500 });
    } else {
      window.setTimeout(loadKlaviyo, 0);
    }
  }

  if (deferred) {
    events.forEach(function (eventName) {
      window.addEventListener(eventName, onInteraction, listenerOptions);
    });
  } else {
    loadKlaviyo();
  }
})();
